var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":"transition","tag":"div"}},_vm._l((_vm.notificationList),function(notification){return _c('notification',_vm._b({key:notification.id},'notification',notification,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }